import { gql } from 'apollo-boost'

const START_CRAWLING_SESSION = gql`
  mutation startCrawlingSession($type: MenuCrawlingSessionType!) {
    startCrawlingSession(type: $type) {
      id
    }
  }
`

export default START_CRAWLING_SESSION

